<script>
import gsap from 'gsap';
export default {
  name: "rightBox",
  data() {
    return {
      show: false
    }
  },
  methods: {
    handleScroll() {
      const scroll = document.body.scrollTop || window.scrollY || document.documentElement.scrollTop;
      this.show = scroll > 600;
    }
  },
  created() {
    // alert('挂在')
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  }
}
</script>

<template>
  <div v-show="show" ref="rightBox" class="rightBannerBox" style="position: fixed;right:20px;top:200px;width:100px;background-color: #ffffff;z-index: 100;">
    <div style="text-align: center;"><img src="../../images/CPXQ28.jpg" style="width: 90px;height: 90%;margin-top: 5px;margin-bottom: 5px;"/></div><!--dm_emt-->
    <ul class="zc_filxed"  >
      <li><router-link to="/register" target="_blank">展商报名</router-link></li>
      <li><a href="https://zh.heavenk.com/swz/registration.html" target="_blank">观众登记</a></li>
      <li><a href="https://admin.nxhzy.cn/index" target="_blank">展商后台</a></li>
    </ul>
  </div>
</template>

<style scoped>
.zc_filxed {
  width: 100%;
  list-style: none;
}
.zc_filxed li{
  text-align: center;
  border-top: 2px solid #dee7f8;
}
.zc_filxed li:hover{
  text-align: center;
  border-top: 2px solid #dee7f8;
  color:#fff ;
  background-color: #150e52;
}
.zc_filxed li a{
  text-decoration: none;
  display:block;
  color: #150e52;
  line-height: 40px;
}
.zc_filxed li a:hover{
  text-decoration: none;
  color: #fff;
  line-height: 40px;
}
</style>
